export default {"src":"/_next/static/media/kosher.2a03a1a2.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};